module.exports = "/_next/static/images/case-tracker-screenshot-1-970960858ca719782a0f772add350b9d.png";